import * as React from "react";
import PageHeaderView from "../../body/PageHeaderView";
import PageContentView from "../../body/PageContentView";
import CustomField from "../../../model/customField/CustomField";
import {none, option, Option} from "ts-option";
import CustomFieldsTable from "./CustomFieldsTable";
import Loading from "../../ui/loading/Loading";
import CreateCustomFieldModal from "./modal/CreateCustomFieldModal";
import EditCustomFieldModal from "./modal/EditCustomFieldModal";
import ButtonPrimary from "../../../hiberUiKit/src/atoms/Buttons/ButtonPrimary";
import ButtonGroupWrapper from "../../../hiberUiKit/src/atoms/Buttons/ButtonGroupWrapper";
import {OnFailure, OnSuccess, OnSuccessData} from "../../../store/action/actionHelpers";

interface ComponentProps {
	/**
	 * Fetch custom fields method
	 */
	fetchCustomFields: () => void;
	/**
	 * Create custom field.
	 * @param {CustomField} customField
	 * @param {OnSuccess} onSuccess
	 * @param {OnFailure} onFailure
	 */
	createCustomField: (customField: CustomField, onSuccess: OnSuccessData<CustomField>, onFailure: OnFailure) => void;
	/**
	 * Update custom field.
	 * @param {CustomField} customField
	 * @param {OnSuccess} onSuccess
	 * @param {OnFailure} onFailure
	 */
	updateCustomField: (customField: CustomField, onSuccess: OnSuccess, onFailure: OnFailure) => void;
	/**
	 * Page title
	 */
	pageTitle: string;
	/**
	 * Custom fields list.
	 */
	customFields: Option<CustomField[]>;
	/**
	 * Missing data text
	 */
	noDataText?: string;
}

interface IState {
	/**
	 * Show / hide create modal flag
	 */
	createModalVisible: boolean;
	/**
	 * Custom field to edit
	 */
	customFieldToEdit: Option<CustomField>;
}

export default class CustomFieldsView extends React.Component<ComponentProps, IState> {

	constructor(props: ComponentProps) {
		super(props);
		this.state = {
			createModalVisible: false,
			customFieldToEdit: none
		};
		this.closeCreateModal = this.closeCreateModal.bind(this);
		this.closeEditModal = this.closeEditModal.bind(this);
		this.handleRowClick = this.handleRowClick.bind(this);
	}

	componentDidMount() {
		this.props.fetchCustomFields();
	}

	render() {
		return (
			<React.Fragment>
				<PageHeaderView header={this.props.pageTitle}>
					<ButtonGroupWrapper>
						<ButtonPrimary onClick={() => {this.setState({createModalVisible: true})}}
									   label={"Create custom field"}
									   variant={"burgundy"}/>
					</ButtonGroupWrapper>
				</PageHeaderView>
				<PageContentView>
					<Loading isLoading={this.props.customFields.isEmpty}>
						<CustomFieldsTable customFields={this.props.customFields.getOrElse([])}
										   onRowClick={this.handleRowClick}
										   noDataText={this.props.noDataText}/>
					</Loading>
				</PageContentView>
				{this.state.createModalVisible &&
				<CreateCustomFieldModal createCustomField={this.createCustomField}
										onCancel={this.closeCreateModal}/>}
				{this.state.customFieldToEdit.isDefined &&
				<EditCustomFieldModal customField={this.state.customFieldToEdit.get}
									  updateCustomField={this.updateCustomField}
									  onCancel={this.closeEditModal}/>}
			</React.Fragment>
		);
	}

	updateCustomField = (customField: CustomField, onActionFinish: () => void) =>
		this.props.updateCustomField(customField, () => {
			onActionFinish();
			this.closeEditModal();
		}, onActionFinish);

	createCustomField = (customField: CustomField, onActionFinish: () => void) =>
		this.props.createCustomField(customField, () => {
			onActionFinish();
			this.closeCreateModal();
		}, onActionFinish);

	closeCreateModal() {
		this.setState({createModalVisible: false});
	}

	closeEditModal() {
		this.setState({customFieldToEdit: none});
	}

	handleRowClick(customField: CustomField) {
		this.setState({customFieldToEdit: option(customField)});
	}
}